<template>
  <div>
    <el-dialog
      title="提示"
      width="480px"
      :show-close="!isTypeName.includes(typeName)"
      :close-on-click-modal="!isTypeName.includes(typeName)"
      :visible.sync="isTitle">
      <div class="titleDialog" slot="title">
        <p>考生须知</p><i></i>
      </div>
      <div class="isTitleText">
        <p><i class="iconfont icontishi"></i>{{ mainText }}</p>
        <span>{{ describeText }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancel" @click="isTitle = false" v-if="!isTypeName.includes(typeName)">取 消</el-button>
        <el-button type="primary" @click="isRouterReturn()">{{typeName === 'submit'? '确定提交' : '确 定' }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { setStore } from "@/utils/localStorage";
export default {
  name: "promptBox",
  data() {
    return {
      isTitle: false,
      mainText: '',
      describeText: '',
      typeName: '',
      isTypeName: ['fullScreen', 'leave', 'isFullScreen']
    }
  },
  methods: {
    isOpen(type) {
      this.isTitle = true;
      this.typeName = type;
      if(type === 'return') {
          this.mainText = '是否强制退出';
          this.describeText = '如强制退出，只计算当前已做的题目分数'
      }
      if(type === 'submit') {
        this.mainText = '是否确认交卷?';
        this.describeText = '考试完成后，请仔细查阅试题'
      }
      if(type === 'leave') {
        this.mainText = '非法操作,下一次系统将强制提交试卷!';
        this.describeText = '你试图离开当前窗口,系统将自动提交试卷!'
      }
      if(type === 'fullScreen') {
        this.mainText = '为了公平公正的考试，请开启全屏模式';
        this.describeText = ''
      }
      if(type === 'isFullScreen') {
        this.mainText = '您已退出全屏';
        this.describeText = '请不要进行切屏等违规操作，离开本页面超过15s，系统将强制交卷'
      }
    },
    isClose() {
      this.isTitle = false;
    },
    isRouterReturn() {
      if(this.typeName === 'return') {
        this.$router.go(-1);
        this.$emit('getRadioSelect');
        this.$emit('clearData');
      };
      if(this.typeName === 'submit') this.$emit('setSubmit', this.typeName)
      if(this.typeName === 'leave') this.isClose()
      if(this.typeName === 'fullScreen') this.toggleFullscreen()
      if(this.typeName === 'isFullScreen') this.isToggleFullscreen()
    },
    isToggleFullscreen() {
      this.isTitle = false;
    },
    //全屏显示
    toggleFullscreen() {
      this.isTitle = false;
      setStore('isFullScreen', true);
      const element = document.documentElement;
      if(element.requestFullscreen) {
        element.requestFullscreen();
      } else if(element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if(element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
      } else if(element.msRequestFullscreen) {
        element.msRequestFullscreen();
      }
    },
  }
}
</script>

<style scoped>
.titleDialog{border-bottom: 1px solid #E8E8E8;padding-bottom: 18px;}
.isTitleText{display: flex;align-items: center;flex-direction: column;padding: 20px 0}
.isTitleText p{font-size: 18px;color: #666;display: flex;align-items: center}
.isTitleText i{font-size: 24px;color: #2C57FF;margin-right: 10px}
.isTitleText span{font-size: 14px;color: #999;margin-top: 5px}
.dialog-footer{display: flex;justify-content: center}
.dialog-footer .cancel{margin-right: 10px}
</style>
